'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _addClassName = require('../utils/add-class-name');

var _addClassName2 = _interopRequireDefault(_addClassName);

var _VstButton = require('./VstButton');

var _VstButton2 = _interopRequireDefault(_VstButton);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstProgressButton = function (_VstComponent) {
  _inherits(VstProgressButton, _VstComponent);

  function VstProgressButton() {
    _classCallCheck(this, VstProgressButton);

    var _this = _possibleConstructorReturn(this, (VstProgressButton.__proto__ || Object.getPrototypeOf(VstProgressButton)).call(this));

    _this._incrementProgress = _this._incrementProgress.bind(_this);
    _this._clearTimeouts = _this._clearTimeouts.bind(_this);
    _this._reset = _this._reset.bind(_this);
    _this._onClick = _this._onClick.bind(_this);
    _this.state = { progress: 0 };
    return _this;
  }

  _createClass(VstProgressButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._clearTimeouts();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var f = function f(p) {
        _this2._clearTimeouts();
        _this2.setState({ progress: p });
        setTimeout(_this2._reset, 1300);
      };

      if (nextProps.success) {
        f(100);
      } else if (nextProps.success === false) {
        f(100);
      }
    }
  }, {
    key: '_clearTimeouts',
    value: function _clearTimeouts() {
      clearTimeout(this._incrementTimeout);
    }
  }, {
    key: '_incrementProgress',
    value: function _incrementProgress(el) {
      var _this3 = this;

      this._incrementTimeout = setTimeout(function () {
        var newProgress = _this3.state.progress + Math.floor(Math.random() * 10);
        newProgress = Math.min(newProgress, 99);
        _this3.setState({ progress: newProgress });
        _this3._incrementProgress(el);
      }, 100);
    }
  }, {
    key: '_reset',
    value: function _reset() {
      this.setState({ progress: 0 });
      if (this.props.onReset) {
        this.props.onReset();
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(e) {
      if (this.state.progress === 0) {
        this._incrementProgress(this.refs.progress);
      }
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = (0, _addClassName2.default)(this.props, 'vst-progress-button');

      var buttonText = void 0;
      if (this.props.success) {
        buttonText = this.props.successText || 'Done';
      } else if (this.props.success === false) {
        buttonText = this.props.failureText || 'Failed';
      } else if (this.state.progress > 0) {
        buttonText = this.props.progressText || 'Saving...';
      } else {
        buttonText = this.props.children;
      }

      var isSuccess = this.props.success && this.state.progress >= 100;
      var isFailure = this.props.success === false;

      return _react2.default.createElement(
        _VstButton2.default,
        _extends({}, (0, _copyProps2.default)(props, ['success', 'progressText', 'failureText', 'successText']), { onClick: this._onClick }),
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)('wrapper', { success: isSuccess, failure: isFailure }) },
          _react2.default.createElement(
            'span',
            { className: 'content', ref: 'text' },
            buttonText
          ),
          _react2.default.createElement('span', { className: (0, _classnames2.default)('progress', { 'no-transition': this.state.progress === 0 || this.state.progress === 100 }),
            style: { width: this.state.progress + '%', backgroundColor: this._theme(9) },
            ref: 'progress'
          })
        )
      );
    }
  }]);

  return VstProgressButton;
}(_VstComponent3.default);

exports.default = VstProgressButton;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstProgressButton.js
 **/